import { render, staticRenderFns } from "./DetailPageBreadcrumb.vue?vue&type=template&id=6eb9b5b4&"
import script from "./DetailPageBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./DetailPageBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./DetailPageBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports